// removed by extract-text-webpack-plugin
module.exports = {"comp-name":"_1vZQ","theme-colorbox":"_30PC","color-code":"_2xlm","theme-card":"_7zkd","hash-code":"_oPkR"};


//////////////////
// WEBPACK FOOTER
// ./checkout/components/colorbar/style.css
// module id = 7Tn3
// module chunks = 4